/** @jsx jsx */

import { ComponentProps } from 'react';

import { Link as ZinniaLink } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    display: block;
    width: auto;
    cursor: pointer !important;
    &,
    &:focus,
    &:hover {
      text-decoration: none !important;
    }
  `,
};

type Props = ComponentProps<typeof ZinniaLink>;

function BlockLink(props: Props) {
  const { children, className, href, onPress, target, ...restProps } = props;

  return (
    <ZinniaLink
      {...restProps}
      className={className}
      css={Styles.root}
      href={href}
      onPress={onPress}
      target={target}
    >
      {children}
    </ZinniaLink>
  );
}

export default BlockLink;
